import { ReactComponent as FirstHomeScreen } from 'svg/firstTimeScreen.svg';
import { Button, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './firstScreen.module.css';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/routes';

const FirstScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCompleteForm = () => {
    navigate(ROUTES.ORGANIZATIONS.CREATE);
  };

  return (
    <Flex flex={1} justify={'center'} align={'center'} vertical>
      <FirstHomeScreen />
      <div className={styles.textStyleContainer}>
        <p>{t('first-screen-text')}</p>
      </div>
      <div>
        <Button type="primary" onClick={handleCompleteForm}>
          {t('first-screen-complete')}
        </Button>
      </div>
    </Flex>
  );
};

export default FirstScreen;
